import createImageIcon from './createImageIcon';
import path from './hour-glass-medium.svg';

export default createImageIcon({displayName: 'HourGlassMediumIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/HourGlassMediumIcon.js